import { ReactNode } from 'react';
import { cn } from '@ds';
import TabSection from '../TabSection/TabSection';
import { DonorType, OrganType } from '@/api/apis/case';
import { AcceptanceCriteriaRows } from './AcceptanceCriteriaRows';
import SectionCard from '../SectionCard/SectionCard';
import { OrganAcceptanceCriteriaFields } from '@/api/apis/cases';

type AcceptanceCriteriaProps = {
  titleIcon?: {
    src: string;
    classNames: string;
  };
  title: string;
  organType: OrganType;
  donorType: DonorType;
  organAcceptanceCriteria: OrganAcceptanceCriteriaFields;
  actionRender?: ReactNode;
  classNames?: {
    tabSectionTitle?: string;
    sectionCardWrapper?: string;
  };
};

export const AcceptanceCriteriaTab = ({
  titleIcon,
  title,
  organType,
  donorType,
  organAcceptanceCriteria,
  actionRender,
  classNames,
}: AcceptanceCriteriaProps) => {
  return (
    <TabSection
      titleIcon={titleIcon}
      title={title}
      actionRender={actionRender}
      titleClassName={classNames?.tabSectionTitle}
    >
      <SectionCard className={cn('px-2 py-2', classNames?.sectionCardWrapper)}>
        <AcceptanceCriteriaRows
          organType={organType}
          donorType={donorType}
          organAcceptanceCriteria={organAcceptanceCriteria}
        />
      </SectionCard>
    </TabSection>
  );
};
